import { IDeleteAfastamentoUseCase } from "../../../presentation/useCases/delete/delete_afastamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteAfastamentoUseCase
 */

export class DeleteAfastamentoUseCase implements IDeleteAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteAfastamento(idAfastamento: number): Promise<void> {
    await this.repository.deleteAfastamento(idAfastamento);
  }
}